import SubNavBar from '../components/SubNavBar'

const Video = () => {
    return (
        <>
            <SubNavBar />
        </>
    )
}

export default Video
